require('./impositionEarlyCancel.scss');

//@vendors
const React = require('react');
const PropTypes = require('prop-types');
const { withRouter } = require('react-router-dom');
// @core
const { formatText } = require('core/i18n').i18n;

// @components
const { OKCover } = require('commonsComponents/OKCover');
const OKHeaderLanding = require('components/commons/OKHeaderLanding/OKHeaderLanding');
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
const { LoadingSection } = require('commonsComponents/loadingSection');
const CustomMessageBox = require('components/contactCenter/customMessageBox/customMessageBox');
const VerifyOtpStep = require('components/commons/verifyOtpStep/verifyOtpStep');
const { EARLY_IMPOSITION_CANCEL } = require('constants/contactCenter/operationTypes');
const ImpositionEarlyCancelStep1 = require('./impositionEarlyCancelStep1/impositionEarlyCancelStep1');
const PreleaveCancelModal = require('components/contactCenter/preleaveCancelModal/preleaveCancelModal');

// @wizard
const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');
const { WIZARD_VERTICAL_VIEW_MODE } = require('constants/index');

// @constants
const {
    IDLE,
    FETCHING,
    FETCHED,
    FETCH_FAILED,
    SAVING,
    SAVED,
    SAVE_FAILED,
} = require('constants/contactCenter/depositOrImpositionCancellationStatus');

class ImpositionEarlyCancel extends React.Component {

    constructor(props) {
        super(props);
        this.handleFinish = this.handleFinish.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleShowCancelModal = this.handleShowCancelModal.bind(this);
        this.handleHideCancelModal = this.handleHideCancelModal.bind(this);
        this.onHandleGoBack = this.onHandleGoBack.bind(this);
    }

    componentWillMount() {
        if (!this.props.immDeposits.has('byId')) {
            this.props.requestDeposits();
        } else {
            this.requestInformation(this.props);
        }
    }

    componentWillReceiveProps(nextProps) {
        if (!this.props.immDeposits.has('byId')
            && nextProps.immDeposits.has('byId')
        ) {
            this.requestInformation(nextProps);
        }
    }

    handleCancel() {
        const {
            history,
            match: { params: { depositId, impositionId } },
        } = this.props;

        const cancelPath = `/myprofile/deposits/${depositId}/imposition/${impositionId}/`;
        history.push(cancelPath);
    }

    onHandleGoBack() {
        const depositsPath = `/myprofile/deposits`;
        this.props.history.push(depositsPath);
    }

    buildPreleaveCancelModal() {

        const { immImpositionEarlyCancellationData } = this.props;
        const showCancelModal = immImpositionEarlyCancellationData.get('showCancelModal');

        return (
            <PreleaveCancelModal
                isOpen={showCancelModal}
                onCancel={this.handleCancel}
                onCloseModal={this.handleHideCancelModal}
                onStayHere={this.handleHideCancelModal}
            />
        );
    }

    requestInformation(props) {
        const {
            match: { params: { depositId, impositionId } },
            requestInterveners,
            queryImpositionEarlyCancellationData,
            immDeposits
        } = props;

        const immDeposit = immDeposits.getIn(['byId', depositId]);
        if (immDeposit) {
            if (!immDeposit.getIn(['interveners', 'list'])) {
                requestInterveners(depositId);
            }
        }

        queryImpositionEarlyCancellationData(depositId, impositionId)

    }

    handleFinish() {
        const {
            match: { params: { depositId, impositionId } },
            earlyCancelImposition,
            immImpositionEarlyCancellationData,
        } = this.props;

        const immCancellationData = immImpositionEarlyCancellationData.getIn(['impositionEarlyCancellation', 'methodResult']);

        earlyCancelImposition(immCancellationData, depositId, impositionId);
    }

    handleShowCancelModal() {
        const { showCancelModal } = this.props;
        showCancelModal(true);
    }

    handleHideCancelModal() {
        const { showCancelModal } = this.props;
        showCancelModal(false);
    }

    buildHeader() {
        return (
            <OKCover size="small" section="deposits">
                <OKHeaderLanding title={formatText('deposits-title')} inputClassName="ok-header-landing--deposits" />
            </OKCover>
        );
    }

    buildLoading() {
        return (
            <OKSectionBox className="imposition-early-cancel-view__content">
                <LoadingSection />
            </OKSectionBox>
        );
    }

    buildWizard() {
        const {
            match: { params: { impositionId, depositId } },
            immImpositionEarlyCancellationData,
            immDeposits,
            immProfile,
            setVisibleStep,
            validateStep,
        } = this.props;

        const immCancellationData = immImpositionEarlyCancellationData.getIn(['impositionEarlyCancellation', 'methodResult']);
        const immDeposit = immDeposits.getIn(['byId', depositId]);
        const currentStep = immImpositionEarlyCancellationData.get('currentStep');
        const immSteps = immImpositionEarlyCancellationData.get('steps');

        const actions = {
            setVisibleStep,
            validateStep,
            setWillCancel: () => { },
            finish: this.handleFinish,
            cancel: this.handleShowCancelModal
        };

        const {
            codigoCentroOcuIDCENT1,
            codigoEmpresaOcuIDEMPR01,
            codigoProductoOcuIDPROD1,
            numeroContratoOcuIDCONTR1,
        } = immCancellationData.toJSON();

        const depositContractNumber = '' + codigoEmpresaOcuIDEMPR01 + codigoCentroOcuIDCENT1
            + codigoProductoOcuIDPROD1 + numeroContratoOcuIDCONTR1;

        const operationParams = {
            originAccount: depositContractNumber,
            optional1: impositionId,
        };

        return (
            <Wizard
                viewMode={WIZARD_VERTICAL_VIEW_MODE}
                actions={actions}
                immSteps={immSteps}
                stepsAmount={3}
                visibleStep={currentStep}
                wizardClass="imposition-early-cancel-view__wizard"
            >
                <WizardStep
                    position="first"
                    cancelButton
                >
                    <ImpositionEarlyCancelStep1
                        immImpositionEarlyCancellationData={immImpositionEarlyCancellationData}
                        immProfile={immProfile}
                        immDeposit={immDeposit}
                        impositionId={impositionId}
                    />
                </WizardStep>
                <WizardStep
                    position="last"
                    omitPreviousButton
                    cancelButton
                    addLoadingBehaviour
                    isLoading={false}
                    immFinalButton="common-confirm"
                >
                    <VerifyOtpStep
                        operationType={EARLY_IMPOSITION_CANCEL}
                        operationParams={operationParams}
                        withValidateButton={false}
                    />
                </WizardStep>
            </Wizard>
        );
    }

    buildSuccessfulFeedback() {
        return (
            <CustomMessageBox
                icon="icon-success"
                title={formatText('cancelImposition-successfulFeedbackTitle')}
                subtitle={formatText('cancelImposition-successfulFeedbackSubtitle')}
                textLink={formatText('cancelImposition-feedbackBackButton')}
                toLink="/myprofile/deposits/"
                goBackHandler={this.onHandleGoBack}
            />
        );
    }

    buildErrorFeedback() {
        return (
            <CustomMessageBox
                icon="icon-warning"
                title={formatText('cancelImposition-failureFeedbackTitle')}
                subtitle={formatText('cancelImposition-failureFeedbackSubtitle')}
                textLink={formatText('cancelImposition-feedbackBackButton')}
                toLink="/myprofile/deposits/"
                goBackHandler={this.onHandleGoBack}
            />
        );
    }

    render() {
        const { immImpositionEarlyCancellationData } = this.props;
        const status = immImpositionEarlyCancellationData.get('status');

        const header = this.buildHeader();
        let content;

        switch (status) {
            case IDLE:
            case FETCHING:
                content = this.buildLoading();
                break;
            case FETCHED:
            case SAVING:
                const wizard = this.buildWizard();
                const preleaveCancelModal = this.buildPreleaveCancelModal();
                content = (
                    <div>
                        {wizard}
                        {preleaveCancelModal}
                    </div>
                );
                break;
            case FETCH_FAILED:
                content = this.buildErrorFeedback();
                break;
            case SAVED:
                content = this.buildSuccessfulFeedback();
                break;
            case SAVE_FAILED:
                content = this.buildErrorFeedback();
                break;
        }

        return (
            <div className="imposition-early-cancel-view">
                {header}
                <div className="imposition-early-cancel-view__body">
                    {content}
                </div>
            </div>
        );
    }
}

ImpositionEarlyCancel.propTypes = {
    history: PropTypes.object.isRequired,
    immProfile: PropTypes.object.isRequired,
    immImpositionEarlyCancellationData: PropTypes.object.isRequired,
    immDeposits: PropTypes.object.isRequired,
    queryImpositionEarlyCancellationData: PropTypes.func.isRequired,
    earlyCancelImposition: PropTypes.func,
    requestDeposits: PropTypes.func.isRequired,
    requestInterveners: PropTypes.func.isRequired,
    match: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired,
    showCancelModal: PropTypes.func.isRequired,
};

module.exports = withRouter(ImpositionEarlyCancel);
